const initialState = {
  mails: null, // media object
  currentMail: null,
  isOpen: false,
  area: null
};

export const mailViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_MAIL_VIEWER": {
      return initialState;
    }
    case "OPEN_MAIL_VIEWER": {
      return { ...state, ...action.viewer };
    }
    case "SET_CURRENT_MAIL_VIEWER": {
      return { ...state, currentMail: action.media };
    }
    case "FETCH_SINGLE_MAIL_FULFILLED": {
      const { data } = action.payload;
      return {
        ...state,
        currentMail: { ...data }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mail-viewer.js